import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  // 我的优惠券列表
  myCouponlist: [],
  // 订单可用优惠券
  orderCouponList: {},
  // 选中的优惠券信息
  selectedCoupon: {}
};

export default function couponList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取我的优惠券列表
    case ACTION_TYPES.GET_MY_COUPON_LIST:
      result.myCouponlist = payload;
      break;
    // 获取订单可用优惠券
    case ACTION_TYPES.GET_ORDER_COUPON_LIST:
      result.orderCouponList = payload;
      break;
    default:
      result = state;
  }
  return result;
}
